module.exports = __webpack_public_path__ + "img/friend-vbet-mobile.987d81b9.png";